(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-quick-add');
    if (!btn) return;

    // La tarjeta es un <a>: evitar que el clic navegue al producto
    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled || btn.dataset.busy === '1') return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.dataset.busy = '1';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Error ' + r.status);
        // Confirmación con palomita; el cart-drawer abre solo (interceptor de fetch)
        btn.classList.add('is-added');
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.dataset.busy = '';
        }, 1200);
      })
      .catch(function (err) {
        console.error('Quick add error:', err);
        btn.dataset.busy = '';
      });
  });
  } catch(e) { console.error(e); }
})();

})();
